<p>{{ 'component_not_found' | translate }} {{equipmentProperty.name}}</p>
